import React from 'react';
import { MfImportModal } from 'features/compositions';
import { useModalSystem } from '../../../config/context/ModalSystemContext';
import { AuthorizationGuard } from 'features/permissions';
import ExportDataModal from 'features/compositions/components/editable-composition-table/ExportDataModal';

const ModalRenderer = () => {
    const { modalType, modalProps, hideModal } = useModalSystem();

    if (!modalType) return null;

    const ModalComponent = modalRegistry[modalType];

    if (!ModalComponent) {
        // console.warn(`Modal "${modalType}" is not registered.`);
        return null;
    }

    return <ModalComponent {...modalProps} onClose={hideModal} />;
}

export default ModalRenderer;

const modalRegistry = {
    MF_IMPORT: MfImportModal,
    AUTHORIZATION_GUARD: AuthorizationGuard,
    EXPORT_DATA: ExportDataModal,
};